<script setup lang="ts">
import { useRouter } from 'vue-router'
import { Dropdown } from 'floating-vue'

const router = useRouter()

const dashboard = () => {
  router.push('/dashboard')
}

const documents = () => {
  router.push('/documents')
}

const autoPaymentSettings = () => {
  router.push('/autoPaymentSettings')
}

const orderHistory = () => {
  router.push('/orderHistory')
}

const invoiceHistory = () => {
  router.push('/invoiceHistory')
}

const accountSettings = () => {
  router.push('/accountSettings')
}

const aiAssistant = () => {
  router.push('/aiAssistant')
}

const accessibilityStatement = () => {
  router.push('/accessibilityStatement')
}
</script>

<template>
  <Dropdown :distance="6">
    <!-- This will be the popover reference (for the events and position) -->
    <slot></slot>
    <!-- This will be the content of the popover -->
    <template #popper>
      <div class="account m-2">
        <div class="flex mt-2">
          <Button text @click="documents">{{ $t('s.accountLink.documents') }}</Button>
        </div>
        <div class="flex mt-2">
          <Button text @click="orderHistory">{{ $t('s.accountLink.orders') }}</Button>
        </div>
        <div class="flex mt-2">
          <Button text @click="invoiceHistory">{{ $t('s.accountLink.invoices') }}</Button>
        </div>
        <div class="flex mt-2">
          <Button text @click="autoPaymentSettings">{{
            $t('s.accountLink.autoPaymentSettings')
          }}</Button>
        </div>
        <div class="flex mt-2">
          <Button text @click="accountSettings">{{ $t('s.accountLink.accountSettings') }}</Button>
        </div>
        <div class="flex mt-2">
          <Button text data-testid="account-link-ai-assistant" @click="aiAssistant">{{
            $t('s.accountLink.aiAssistant')
          }}</Button>
        </div>
        <div class="flex mt-2">
          <Button text @click="accessibilityStatement">{{
            $t('s.accountLink.accessibilityStatement')
          }}</Button>
        </div>
        <div class="flex mt-2">
          <Button text @click="$emit('logout')">{{ $t('s.accountLink.logout') }}</Button>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<style scoped>
/* The theme's 500 shade fails WCAG AA contrast against white; 800 passes. */
.account {
  --p-button-text-primary-color: var(--p-primary-800);
}
</style>
